import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatSnackBar, MatTab, MatTabGroup } from '@angular/material';
import { ListInterface } from 'src/app/Inteface/list-interface';
import { FeatureModel } from 'src/app/Models/feature-model';
import { Model } from 'src/app/Models/model';
import { DragDropService } from 'src/app/Services/drag-drop.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { FeatureServiceService } from '../../Services/feature-service.service';
import { ConfirmDialogModel, DialogComponent } from '../dialog/dialog.component';


@Component({
  selector: 'ze-canvas-component2',
  templateUrl: './canvas-component2.component.html',
  styleUrls: ['./canvas-component2.component.scss']
})
export class CanvasComponent2Component implements OnInit {
  numbers: Model[] = [{
    fId: 100,
    id: "wdyuwyuwdwj",
    name: "One more feature",
    scenario: ["rettsbxyyn"],
    _type: "feature"
  }]
  private selectedTabInedex: number = 0;
  @ViewChildren(MatTabGroup, { read: MatTabGroup })
  public tabGroup: MatTabGroup;
  @ViewChildren(MatTab, { read: MatTab })
  public tabNodes: QueryList<MatTab>;
  @Output("indexRemoved") private indexRemoved = new EventEmitter<number>();
  @Output("indexSelected") private indexSelectedEmitter = new EventEmitter<number>();
  @Input("tabsList") tabs: ListInterface[] = [];
  @Input("currentIndex") CurrentIndex: ListInterface[];
  @Output() canvas = new EventEmitter();
  @Output("saveAs") saveAs = new EventEmitter();
  @Output("delete") deleteevent = new EventEmitter();
  constructor(
    private featureService: FeatureServiceService,
    private dnd: DragDropService,
    public dialog: MatDialog,
    private notifys: NotifyService,
    private _snackBar: MatSnackBar
  ) { }
  fss: FeatureServiceService;
  features: FeatureModel[];
  ngOnInit() {
    this.featureService.getItems().subscribe(data => {
      this.features = data['data'].filter(Boolean);
    })
  }
  drop(event: CdkDragDrop<any[]>) {
    let temp1 = null;

    if (event.previousContainer.id == event.container.id) {
    }
    else {

      switch (this.tabs[this.selectedTabInedex]._type) {
        case "suite":
          if (event.previousContainer.id == "Suites") {
            this.notifys.notify('warning', 'Not Allowed!', this.tabs[this.selectedTabInedex]._type + ' Cannot be added in ' + event.previousContainer.id);
            return
          }
          break;
        case "feature":
          if (event.previousContainer.id == "Suites" || event.previousContainer.id == "Feature") {
            this.notifys.notify('warning', 'Not Allowed!', this.tabs[this.selectedTabInedex]._type + ' Cannot be added in ' + event.previousContainer.id);
            return
          }
          break;
        case "scenario":
          if (event.previousContainer.id == "Suites" || event.previousContainer.id == "Feature" || event.previousContainer.id == "Scenario") {
            this.notifys.notify('warning', 'Not Allowed!', this.tabs[this.selectedTabInedex]._type + ' Cannot be added in ' + event.previousContainer.id);
            return
          }
          break;
      }
      temp1 = {
        model: JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex])),
        _type: JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex]))._type,
        deleted: 0
      }
      event.previousContainer.data[event.previousIndex] = temp1;
    }
    if (!event.container.data || !event.previousContainer.data) {
      return;
    }
    this.dnd.drop(event);
    if (temp1) {
      event.previousContainer.data[event.previousIndex] = temp1.model;
    }
}
  closeTab(index: number) {
    event.stopPropagation();
    this.indexRemoved.emit(index);
    this.tabGroup.selectedIndex = this.tabNodes.length - 1;
  }
  tabChanged(number: number) {
    event.stopPropagation();
    this.selectedTabInedex = number;
    this.indexSelectedEmitter.emit(number);
  }
  saveCanvas() {
    this.canvas.emit(this.tabs[this.selectedTabInedex]);
  }
  delete(item, i) {
    if (item._id == undefined) {
      this.tabs[this.selectedTabInedex]['model'].splice(i, 1);
    }
    else {
      this.deleteConfirmation(item);
    }
  }
  deleteConfirmation(item) {
    const message = `Please save the changes !`;
    const dialogData = new ConfirmDialogModel("Delete !!!", message);
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.deleteevent.emit(item);
      }
      else {
        this.notifys.notify('warning', 'Aborted', "Deletion Aborted By User!!!");
      }
    });
  }
  openSnackBar() {
    this.notifys.notify('success', 'Success', "Save Successfully");
  }

  saveAsCanvas() {
    this.saveAs.emit(this.tabs[this.selectedTabInedex]);
  }
}
